import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "./port1.css";
import App6 from './port2'; 
import App7 from './port3'; 
import Footer from "./footer";
import Header1 from './header1';

const Frame = () => {
  const [showApp6, setShowApp6] = useState(false);
  const [showApp7, setShowApp7] = useState(false);
  const [showFooter, setshowFooter] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;

      // You can adjust the scroll threshold as needed
      if (scrollPosition > 500) {
        setShowApp6(true);
      } else {
        setShowApp6(false);
      }
      if (scrollPosition > 500) {
        setShowApp7(true);
      } else {
        setShowApp7(false);
      }
      if (scrollPosition > 700) {
        setshowFooter(true);
      } else {
        setshowFooter(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
   
    <div>
      <div className='header1'>
        <Header1 />
      </div>
    <div className="frame-parentx">
      <div className="rectangle-parentx">
      <a href='/'>
      <p className='titlename2'>VREON TECH INDIA PVT LTD</p>
      </a>
        <div className="frame-childx" />
        <b className="homex" >
         <Link to="/">HOME</Link>
        </b>
        <b className="aboutx" >
         <Link to="/about">ABOUT</Link>
        </b>
        <b className="servicex" >
         <Link to="/service">SERVICES</Link>
        </b>
        <b className="portfoliox" >
         <Link to="/portfolio">PORTFOLIO</Link>
        </b>
        <b className="ourproductsx" >
         <Link to="/products">PRODUCTS</Link>
        </b>
        <b className="contactx" >
         <Link to="/contact">CONTACT</Link>
        </b>
        <a href='/'>
        <img className="logo-1-iconx" alt="" src="/logo.png" />
        </a>
      </div>
      {/* <img className="gradient-1-iconx" alt="" src="/gradient.png" /> */}
      <div className="casex">Case</div>
      <b className="studiesx">Studies</b>
      <img className="kalvi-1-iconx" alt="" src="/kalvi.png" />
      <div className="kalvi-30x">Kalvi 3.0</div>
      <div className="a-virtual-classroomx">
        A virtual classroom for school children
      </div>
      <div className="we-have-developedx">
        We have developed an activity- based VR classroom for school children
        that focuses on promoting easy learning through immersive and
        interactive sessions in Tuticorin Corporation Schools .
      </div>
      <img className="sciencepark-1-iconx" alt="" src="/sciencepark.png" />
      <img className="library-1-iconx" alt="" src="/library.png" />
      <img className="human-1-iconx" alt="" src="/human.png" />
      <img className="vrkalvi-1-iconx" alt="" src="/VRkalvi.png" />
      <div className="science-parkx">Science Park</div>
      <div className="a-vr-edutainmentx">
        A VR edutainment for school children
      </div>
      <div className="we-have-developed1x">{`We have developed a VR- based Science Park that features Jungle Safari, Jurassic Park, Space Ride& Underwater for the children at STEM PARK, Tuticorin .`}</div>
      <div className="a-model-kalaignarx">{`A Model Kalaignar Memorial Library `}</div>
      <div className="a-virtual-realityx">A Virtual Reality model library</div>
      <div className="we-have-developed2x">
        We have developed a model Kalaignar Memorial Library for the Public
        Works Department that served as a comprehensive demo for the
        construction project in Madurai .
      </div>
      <div className="human-body-systemx">Human Body System</div>
      <div className="a-virtual-reality1x">
        A Virtual Reality Lab at the college
      </div>
      <div className="we-have-developed3x">
        We have developed a virtual lab for college students that explains the
        human body's anatomy and organs at Pannai Pharmacy College, Dindigul
      </div>
      <div className="vr-kalvi-30x">VR Kalvi 3.0</div>
      <div className="a-virtual-classroom1x">
        A virtual classroom for school children
      </div>
      <div className="we-have-developed4x">
        We have developed an activity- based VR classroom for school children
        that teaches traffic rules and established a VR Chemistry lab at Pannai
        Schools .
      </div>
    </div>
    </div>
  );
};

const App = () => {
  return (
    <div className="App">
      <Frame />
      <App6 />
      <App7 />
      <Footer />
    </div>

    
  );
};

export default App;

